/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { IBvIconArgs } from '../bv-icon';
import type { BvTextSignature } from '../bv-text';

interface CodeDescSignature {
  Args: {
    code?: string;
    desc?: string;
    fontVariant?: BvTextSignature['Args']['variant'];
    icon?: IBvIconArgs['glyph'];
    iconColor?: IBvIconArgs['color'];
    iconSize?: IBvIconArgs['size'];
  };
  Element: HTMLElement;
}

const CodeDescComponent = templateOnlyComponent<CodeDescSignature>();

export default CodeDescComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CodeDesc: typeof CodeDescComponent;
    'code-desc': typeof CodeDescComponent;
  }
}
